export default "__VITE_ASSET__CIxHx3jl__"